"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateEzbuyDomain = generateEzbuyDomain;
exports.generateBlazerDomain = generateBlazerDomain;
exports.generateLITBDomain = generateLITBDomain;

var _types = require("./types");

function generateEzbuyDomain(_ref) {
  var _region$replace;

  var _ref$region = _ref.region,
      region = _ref$region === void 0 ? _types.Region.SG : _ref$region,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      _ref$language = _ref.language,
      language = _ref$language === void 0 ? "en" : _ref$language,
      _ref$env = _ref.env,
      env = _ref$env === void 0 ? 1 : _ref$env,
      kenv = _ref.kenv;
  var catalog = region === null || region === void 0 ? void 0 : (_region$replace = region.replace(/twc/i, "tw")) === null || _region$replace === void 0 ? void 0 : _region$replace.toLowerCase();
  var isOthers = [_types.Region.TWC, _types.Region.PK].some(function (r) {
    return r === region;
  });
  var uatGroups = {},
      onlineGroups = {};
  var apiPrefix = "".concat(region, "-").concat(language === null || language === void 0 ? void 0 : language.toLowerCase(), "-").concat(isMobile ? "mweb" : "web", "-%SERVICE_TYPE%"); // const uatEnv = env > 1 ? env : "";

  uatGroups.cookieDomain = ".ezbuy.dev";
  uatGroups.webDomain = "".concat(kenv ? "".concat(kenv, "-") : "").concat(catalog).concat(uatGroups.cookieDomain);
  uatGroups.mwebDomain = "m-".concat(catalog).concat(kenv ? "-".concat(kenv) : "").concat(uatGroups.cookieDomain);
  uatGroups.apiDomain = "".concat(apiPrefix).concat(kenv ? "-".concat(kenv, "-api") : "").concat(uatGroups.cookieDomain);

  if (isOthers) {
    onlineGroups.cookieDomain = ".ezbuy.com";
    onlineGroups.webDomain = "".concat(catalog).concat(onlineGroups.cookieDomain);
    onlineGroups.mwebDomain = "m-".concat(onlineGroups.webDomain);
  } else {
    onlineGroups.cookieDomain = ".ezbuy.".concat(region === _types.Region.TH ? "co." : "").concat(catalog);
    onlineGroups.webDomain = onlineGroups.cookieDomain.slice(1);
    onlineGroups.mwebDomain = "m.".concat(onlineGroups.webDomain);
  }

  onlineGroups.apiDomain = "".concat(apiPrefix).concat(onlineGroups.cookieDomain);
  return {
    uatGroups: uatGroups,
    onlineGroups: onlineGroups
  };
}

function generateBlazerDomain(_ref2) {
  var _ref2$region = _ref2.region,
      region = _ref2$region === void 0 ? _types.Region.AUE : _ref2$region,
      _ref2$isMobile = _ref2.isMobile,
      isMobile = _ref2$isMobile === void 0 ? false : _ref2$isMobile,
      _ref2$language = _ref2.language,
      language = _ref2$language === void 0 ? "en" : _ref2$language;
  var uatGroups = {},
      onlineGroups = {};
  var apiPrefix = "".concat(region, "-").concat(language === null || language === void 0 ? void 0 : language.toLowerCase(), "-").concat(isMobile ? "mweb" : "web", "-%SERVICE_TYPE%");
  uatGroups.webDomain = "web.ezbuy.dev";
  uatGroups.mwebDomain = "m.ezbuy.dev";
  uatGroups.cookieDomain = isMobile ? uatGroups.mwebDomain : uatGroups.webDomain;
  uatGroups.apiDomain = "".concat(apiPrefix, ".ezbuy.dev");
  onlineGroups.webDomain = "www.ezbuy.com";
  onlineGroups.mwebDomain = "m.ezbuy.com";
  onlineGroups.cookieDomain = isMobile ? onlineGroups.mwebDomain : onlineGroups.webDomain;
  onlineGroups.apiDomain = "".concat(apiPrefix, ".ezbuy.com");
  return {
    uatGroups: uatGroups,
    onlineGroups: onlineGroups
  };
}

function generateLITBDomain(_ref3) {
  var isMobile = _ref3.isMobile,
      _ref3$language = _ref3.language,
      language = _ref3$language === void 0 ? "en" : _ref3$language;
  var uatGroups = {},
      onlineGroups = {};
  var apiPrefix = "litb-".concat(language, "-").concat(isMobile ? "mweb" : "web", "-api");
  uatGroups.cookieDomain = ".lightinthebox.com";
  uatGroups.webDomain = "www".concat(uatGroups.cookieDomain);
  uatGroups.mwebDomain = "m".concat(uatGroups.cookieDomain);
  uatGroups.apiDomain = "".concat(apiPrefix, ".65emall.net");
  onlineGroups.cookieDomain = ".lightinthebox.com";
  onlineGroups.webDomain = "www".concat(onlineGroups.cookieDomain);
  onlineGroups.mwebDomain = "m".concat(onlineGroups.cookieDomain);
  onlineGroups.apiDomain = "".concat(apiPrefix, ".lightinthebox.com");
  return {
    uatGroups: uatGroups,
    onlineGroups: onlineGroups
  };
}